import * as jsxRuntime from "/Users/baby/development/code/bading/barding-edu-front/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment